(function (Drupal) {
  function getScrollTarget() {
    return document.querySelector('.insight-search-listing__filters') || document.querySelector('.views-element-container .search-wrapper');
  }

  function scrollToElement(el) {
    if (!el) return;

    setTimeout(function () {
      var headerOffset = document.querySelector('header.site-header, .site-header, header');
      var offset = headerOffset ? headerOffset.offsetHeight : 0;
      var top = el.getBoundingClientRect().top + window.scrollY - offset - 20;

      window.scrollTo({ top: top, behavior: 'smooth' });

      if (!el.hasAttribute('tabindex')) {
        el.setAttribute('tabindex', '-1');
      }
      el.focus({ preventScroll: true });
    }, 300);
  }

  Drupal.behaviors.listingPageScroll = {
    attach: function (context) {
      if (context === document && Drupal.AjaxCommands && Drupal.AjaxCommands.prototype) {
        var originalScrollTop = Drupal.AjaxCommands.prototype.scrollTop;
        Drupal.AjaxCommands.prototype.scrollTop = function (ajax, response) {
          if (getScrollTarget()) {
            window.__listingScrollPending = true;
          } else {
            originalScrollTop.call(this, ajax, response);
          }
        };
        return;
      }

      if (context !== document && window.__listingScrollPending) {
        window.__listingScrollPending = false;
        var target = getScrollTarget();
        if (target) {
          scrollToElement(target);
        }
      }
    },
  };

  function scrollToResults() {
    var hasSearchParams = window.location.search.length > 0;
    if (!hasSearchParams) return;

    scrollToElement(getScrollTarget());
  }

  window.addEventListener('DOMContentLoaded', function () {
    scrollToResults();
  });
})(Drupal);
